// RFC 4180 style parser: quoted fields, "" escapes, commas/newlines inside quotes.
export const parseCSV = (text) => {
  const rows = [];
  let row = [];
  let field = "";
  let quoted = false;
  const src = text.replace(/^﻿/, "");

  for (let i = 0; i < src.length; i++) {
    const c = src[i];
    if (quoted) {
      if (c === '"' && src[i + 1] === '"') { field += '"'; i++; }
      else if (c === '"') quoted = false;
      else field += c;
    } else if (c === '"') quoted = true;
    else if (c === ",") { row.push(field); field = ""; }
    else if (c === "\n" || c === "\r") {
      if (c === "\r" && src[i + 1] === "\n") i++;
      row.push(field); field = "";
      rows.push(row); row = [];
    } else field += c;
  }
  if (field !== "" || row.length) { row.push(field); rows.push(row); }
  return rows.filter((r) => r.some((v) => v.trim() !== ""));
};

const NUMBER_FIELDS = ["cargoQty", "tolerance", "min", "max", "rate", "turnTime", "freight", "adcom", "other", "brokerage", "stowFactor"];
const CARGO_FIELDS = ["name", "freightMode", "qtyMode", "laycanStartDate", "laycanEndDate", "suez", "panama", "message"];
const OP_FIELDS = ["operation", "port", "terms", "account", "cargo", ...NUMBER_FIELDS];

// "2026-07-01" -> "2026-07-01T00:00:00.000Z" so it passes the validator's ISO check
const toIsoDate = (v) => (/^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T00:00:00.000Z` : v);

// Returns { cargo } in the shape validateAIImportData expects, or { error }.
export const csvToCargoData = (text) => {
  const rows = parseCSV(text);
  if (rows.length < 2) return { error: "The CSV file is empty or has no data rows." };

  const header = rows[0].map((h) => h.trim());
  if (!header.includes("port") && !header.includes("name")) {
    return { error: "Invalid CSV. The header row must use the column names from the AI Instruction PDF." };
  }

  const cargo = { portOperations: [] };
  rows.slice(1).forEach((r) => {
    const rec = {};
    header.forEach((h, i) => {
      const v = (r[i] ?? "").trim();
      if (v !== "") rec[h] = v;
    });

    CARGO_FIELDS.forEach((k) => {
      if (rec[k] === undefined || cargo[k] !== undefined) return; // first non-empty value wins
      if (k === "suez" || k === "panama") cargo[k] = rec[k].toLowerCase() === "true";
      else cargo[k] = k.startsWith("laycan") ? toIsoDate(rec[k]) : rec[k];
    });

    const op = {};
    OP_FIELDS.forEach((k) => {
      if (rec[k] === undefined) return;
      const n = Number(rec[k].replace(/,/g, ""));
      if (NUMBER_FIELDS.includes(k)) { if (!Number.isNaN(n)) op[k] = n; }
      else op[k] = rec[k];
    });
    if (Object.keys(op).length) cargo.portOperations.push(op);
  });

  return { cargo };
};
